import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-item dropdown" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["aria-labelledby"]

import { guid } from "@/helpers/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavDropdown',
  props: {
    inverse: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { inverse: boolean };

const instanceId = guid()



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      id: _unref(instanceId),
      href: "#",
      class: "nav-link dropdown-toggle",
      role: "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown-menu", {'dropdown-menu-end': props.inverse}]),
      "aria-labelledby": _unref(instanceId)
    }, [
      _renderSlot(_ctx.$slots, "items")
    ], 10, _hoisted_3)
  ]))
}
}

})